module.exports = __webpack_public_path__ + "img/list3.2b9d367d.png";